<template>
  <v-row>
    <v-col cols="12" md="12">
      <v-form ref="form" v-model="formValid" class="ma-2">
        <v-row>
          <v-col cols="12" sm="12" class="pt-1 pb-1">
            <v-text-field
              outlined
              dense
              label="Business Name"
              required
              :rules="formRules.organization"
              v-model="forms.organization_name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" class="pt-1 pb-1">
            <v-text-field
              outlined
              class="ma-0"
              dense
              label="Person Name"
              required
              :rules="formRules.person"
              v-model="forms.person_name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" class="pt-1 pb-1">
            <v-text-field
              outlined
              class="ma-0"
              dense
              label="Mobile Phone"
              required
              :rules="formRules.mobile_phone"
              v-model="forms.mobile_phone"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" class="pt-1 pb-1">
            <v-text-field
              outlined
              dense
              label="Email"
              required
              :rules="formRules.email"
              v-model="forms.email"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" class="pt-1 pb-1">
            <v-text-field
              outlined
              class="ma-0"
              dense
              label="Password"
              required
              @click:append="show = !show"
              :type="!show ? 'password': 'text'"
              :rules="formRules.password"
              v-model="forms.password"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" class="pt-1 pb-0">
            <v-text-field
              outlined
              class="ma-0"
              dense
              label="Confirm Password"
              required
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="show = !show"
              :type="!show ? 'password': 'text'"
              :rules="formRules.c_password"
              v-model="forms.c_password"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" class="pt-0">
            <v-checkbox v-model="forms.agree" :rules="formRules.agree" class="ma-0">
              <template v-slot:label>
                <div>
                  I agree to the <a href="#">Terms of Service</a> and <a href="#">Privacy Policy</a>
                </div>
              </template>
            </v-checkbox>
          </v-col>
        </v-row>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            block
            large
            color="primary"
            v-on:click="validate()"
          >{{$t('register.control_your_business_now')}}</v-btn>
        </v-card-actions>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
// @ is an alias to /src
/*eslint no-console: "off"*/
export default {
  name: "form_register",
  data() {
    return {
      show: false,
      show2: false,
      formValid: false,
      forms: {
        organization_name: "",
        person_name: "",
        mobile_phone: "",
        email: "",
        password: "",
        c_password: "",
        agree: false,
      },
      formRules: {
        organization: [v => !!v || "Organization is required"],
        person: [v => !!v || "Person Name is required"],
        mobile_phone: [v => !!v || "Mobile Phone is required"],
        email: [
          v => !!v || "Email is required",
          v => /.+@.+\..+/.test(v) || "E-mail must be valid"
        ],
        password: [v => !!v || "Password is required"],
        c_password: [v => !!v || "Confirm Password is required"],
        agree: [v => !!v || ""]
      }
    };
  },
  props: {
    step: Number
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.$emit("ToggleLoading");
        this.saveOrganization();
      }
    },
    async saveOrganization() {
      var vm = this;

      try {
        await this.axios
          .post("https://dev-api.skyware.systems/v0/register", vm.forms)
          .then(function(response) {
            console.log(response);
          });
      } catch (error) {
        console.log(error);
      }

      setTimeout(function() {
        vm.$emit("ToggleLoading");
        vm.$emit("SuccessRegister", {
          email: vm.forms.email
        });
      }, 1000);
    }
  }
};
</script>